import React from 'react';

class ExerciesBlock extends React.Component {
  render() {
    let { index, exercise } = this.props;
    return (
      <div className="exercies-block">
        <h4>Exercise {index+1}</h4>
        <div className="info-content">
          <div>
            <label>Exercise Name</label>
            <span>{exercise.exercise_name}</span>
          </div>
          <div>
            <label>Weight</label>
            <span>{exercise.weight}</span>
          </div>
          <div>
            <label>Tempo</label>
            <span>{exercise.tempo}</span>
          </div>
          <div>
            <label>Rest (Seconds)</label>
            <span>{exercise.rest}</span>
          </div>
        </div>
      </div>
    );
  }
}

export default ExerciesBlock;
